module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "233",
      "src": "images/5.jpg",
      "width": "350"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Want to eat? You need money.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Want to have clothes? Having money is a must.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Electricity, phone, car, gasoline—all cost money.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With money being such a huge factor in how we live, it’s easy to become slaves to the almighty dollar. But the Bible says, “Keep your lives free from the love of money and be content with what you have, because God has said, ‘Never will I leave you; never will I forsake you’” (Hebrews 13:5). This chapter offers beginning steps to becoming financially wise.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('a', {
    attrs: {
      "id": "page_9"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c5082f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part02.vue
// module id = 90
// module chunks = 0